document.addEventListener("DOMContentLoaded", function () {
  // Run only if screen width is 767px or less
  if (window.innerWidth <= 767) {
    // Hide the original product slider on mobile
    const collectionSlider = document.querySelector('.section_collection_slider');
    if (collectionSlider) {
      collectionSlider.style.display = 'none';
    }
    const collectionSliderList = document.querySelector('.rte.page_container li');
    if(collectionSliderList) {
      collectionSliderList.style.listStyle = 'none';
    }

    // Move products before .techminds-subtitle-wrapper elements
    const productCards = document.querySelectorAll('#collection_product_slider li');
    const subtitleWrappers = document.querySelectorAll('.techminds-subtitle-wrapper');

    const totalToInsert = Math.min(productCards.length, subtitleWrappers.length);

    for (let i = 0; i < totalToInsert; i++) {
      const clonedProduct = productCards[i].cloneNode(true);
      subtitleWrappers[i].parentNode.insertBefore(clonedProduct, subtitleWrappers[i]);
    }
  }
});
